import { WATERFALL_SLUG } from 'common/constants/allocations';
import { BREAKPOINT_ANALYSIS_SLUG, CAP_TABLE_SLUG, FUND_OWNERSHIP_SLUG } from 'common/constants/cap-table';
import { COMPANIES_SUMMARY_SLUG } from 'common/constants/companies';
import { DOCUMENTS_SLUG } from 'common/constants/documents';
import { FINANCIAL_SLUG, FINANCIAL_TITLE } from 'common/constants/financials';
import { VALUATIONS_SLUG, VALUATIONS_TITLE } from 'common/constants/valuations';

export const BOTTOM_NAV_HEIGHT = 250;

export const COMPANY_PAGES = [
  {
    id: 0,
    title: 'Summary',
    slug: COMPANIES_SUMMARY_SLUG,
  },
  {
    id: 1,
    title: FINANCIAL_TITLE,
    slug: FINANCIAL_SLUG,
  },
  {
    id: 2,
    title: 'Capitalization Table',
    slug: CAP_TABLE_SLUG,
  },
  {
    id: 3,
    title: 'Fund Ownership',
    slug: FUND_OWNERSHIP_SLUG,
  },
  {
    id: 4,
    title: 'Breakpoint Analysis',
    slug: BREAKPOINT_ANALYSIS_SLUG,
  },
  {
    id: 5,
    title: VALUATIONS_TITLE,
    slug: VALUATIONS_SLUG,
  },
  {
    id: 6,
    title: 'Waterfall',
    slug: WATERFALL_SLUG,
  },
  {
    id: 7,
    title: 'Documents',
    slug: DOCUMENTS_SLUG,
  },
];

export const PINNABLE_TYPES = {
  COMPANY: 'company',
  FUND: 'fund',
  FUND_INVESTMENT: 'fundInvestment',
  FIRM: 'firm',
};